import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteLeagueNew } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew/leaguesNewQueryKeys";

export const useDeleteLeagueNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteLeagueNew(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [LeaguesNewQueryKeys.LeaguesNew],
      });
    },
  });
};
